import { API_URL, jwtToken } from "../../../context/appContext";
export default async function fetchProfileURL(exchange) {
    return fetch(`${API_URL}/api/profile_url/${exchange}`, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + jwtToken
        }
    })
        .then(res => res.json())
        .then(res => res)
        .catch(err => err)
}
